<template>
  <v-layout>
    <v-layout
      v-show="!groupsNames.length"
      class="mt-3"
      justify-center
    >
      No available items
    </v-layout>

    <pb-dashboard-column
      v-for="groupName in groupsNames"
      :key="groupName"
    >
      <template #title>
        <v-layout>
          {{ groupName }}

          <v-spacer />

          {{ generateTimeStrFromHoursMinutesObj(estimatedTime[groupName]) }}
          /
          {{ jobsCountByGroupName[groupName] }}
        </v-layout>
      </template>

      <slot :group="groups[groupName]" />
    </pb-dashboard-column>
  </v-layout>
</template>

<script>
import PbDashboardColumn from './PbDashboardColumn.vue';

import { calculateTotalTime, generateTimeStrFromHoursMinutesObj } from '../_helpers/time';

export default {
  name: 'PbDashboardGroups',

  props: {
    groups: {
      type: Object,
      required: true,
    },
  },

  components: {
    PbDashboardColumn,
  },

  computed: {
    groupsNames() {
      return Object.keys(this.groups).sort();
    },

    jobsCountByGroupName() {
      return this.groupsNames.reduce((acc, groupName) => {
        acc[groupName] = this.groups[groupName]
          .reduce((accCount, { count }) => accCount + count, 0);

        return acc;
      }, {});
    },

    estimatedTime() {
      return this.groupsNames.reduce((acc, groupName) => {
        acc[groupName] = calculateTotalTime({ items: this.groups[groupName] });

        return acc;
      }, {});
    },
  },

  methods: {
    generateTimeStrFromHoursMinutesObj,
  },
};
</script>
